import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { css } from '@emotion/react';
import { visuallyHidden } from '../../../foundations/accessibility/visually-hidden.js';
import { iconSize } from '../../../foundations/__generated__/size.js';

const Svg = ({ size, theme }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size ? iconSize[size] : void 0,
    height: void 0,
    viewBox: "-3 -3 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false,
    "aria-hidden": true,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m1 7.224 10.498 10.498h1.004L23 7.224l-.98-.954L12 14.708 1.98 6.27z",
        fill: theme?.fill
      }
    )
  }
);
const SvgChevronDownSingle = ({
  size,
  theme,
  isAnnouncedByScreenReader = false
}) => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx(Svg, { size, theme }),
  isAnnouncedByScreenReader ? /* @__PURE__ */ jsx(
    "span",
    {
      css: css`
					${visuallyHidden}
				`,
      children: "Expand to show more"
    }
  ) : ""
] });

export { SvgChevronDownSingle };
